import { DISCLAIMER } from '../lib/types';
import styles from './Disclaimer.module.css';

export function Disclaimer({
  text = DISCLAIMER,
  summary,
}: {
  text?: string;
  /**
   * A one-line version. When given, only this line shows until the reader
   * opens it; the full text is one tap away. For pages whose main content
   * would otherwise start below a tall notice (the site-wide "not advice"
   * banner stays on screen either way).
   */
  summary?: string;
}) {
  // Texts that already open with their own "not financial advice" line don't need a second one.
  const hasOwnLead = /not financial advice/i.test(text);
  if (summary) {
    return (
      <div className={`${styles.disclaimer} ${styles.compact}`} role="note">
        <details>
          <summary className={styles.summary}>
            <strong className={styles.lead}>{summary}</strong>
            <span className={styles.more} aria-hidden="true" />
          </summary>
          <p className={styles.full}>{text}</p>
        </details>
      </div>
    );
  }
  return (
    <p className={styles.disclaimer} role="note">
      {!hasOwnLead && (
        <>
          <strong className={styles.lead}>Not financial or betting advice.</strong>{' '}
        </>
      )}
      {text}
    </p>
  );
}
